import { z } from 'zod';

export const PROFILE_SCHEMA = z.object({
  name: z.string().trim().min(2).max(36).optional(),
  email: z.string().email().optional(),
  image: z.string().url().optional(),
  title: z.string().min(2).max(36).optional(),
});
